<template>
  <div class="general-wrapper">
    <div class="header">
      <h2 class="qrw-heading-xl">Marketplace</h2>
    </div>

    <div class="px-50">
      <div class="iqos iqos-long">
          <div class="row">
              <div>
          <h3 class="cafe-name">Cafe name</h3>
          <p class="cafe-address">вулиця Льва Толстого, 3, Ужгород, Закарпатська область, 88000</p>
        
        

        <div class="marketplace-card-controls">
          <div class="mode-row">
            <MarketplaceCheckbox mode="preorder" v-model="modePreorder" />
            <ModeIcon mode="preorder" class="mode-icon">{{billing_account.comission.preorder || 3}}%</ModeIcon>
          </div>

          <div class="mode-row">
            <MarketplaceCheckbox mode="delivery" v-model="modeDelivery" />
            <ModeIcon mode="delivery" class="mode-icon">{{billing_account.comission.delivery || 3}}%</ModeIcon>
          </div>

          <div class="mode-row">
            <MarketplaceCheckbox mode="reserve" v-model="modeReserve" />
            <ModeIcon
              mode="reserve"
              class="mode-icon"
            >{{billing_account.comission.reserve || 5}} UAH</ModeIcon>
          </div>
          </div>
        </div>
         <div class="balance-badge-container ml-auto">
        <div
          :class="{
        'balance-badge': true,
        'red': billing_account.balance < 0
      }"
        >
          9999
          <span class="balance-currency">UAH</span>
        </div>
        <DashboardButton
          class="w-100 mt-15"
        >Налаштування</DashboardButton>
        <DashboardButton
          class="w-100 mt-15 btn-fill-green"
        >Поповнити</DashboardButton>
      </div>
        </div>
        <p class="c-grey comment pt-3 mb-0">Обираючи хоча б одну з систем, Ви автоматично погоджуєтесь з політикою маркетплейсу QRWaiter.</p>
      </div>
    </div>
  </div>
</template>

    
<script>
import ModeIcon from "@/components/ModeIcon.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import MarketplaceCheckbox from "@/components/marketplace/MarketplaceCheckbox.vue";

export default {
  computed: {
    modePreorder: {
      get() {
        return this.cafe.marketplace_modes.preorder;
      },
      set(v) {
        this.$store.commit("setMarketplaceMode", {
          mode: "preorder",
          value: v,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    modeDelivery: {
      get() {
        return this.cafe.marketplace_modes.delivery;
      },
      set(v) {
        this.$store.commit("setMarketplaceMode", {
          mode: "delivery",
          value: v,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    modeReserve: {
      get() {
        return this.cafe.marketplace_modes.reserve;
      },
      set(v) {
        this.$store.commit("setMarketplaceMode", {
          mode: "reserve",
          value: v,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    cafe() {
      return this.$store.state.cafe;
    },
    billing_account() {
      return this.$store.state.billing_account;
    },
  },
  components: {
    ModeIcon,
    MarketplaceCheckbox,
    DashboardButton
  },
};
</script>


<style scoped>

h3.cafe-name {
    font-size: 4vh;
    color: #ededed;
}
p.cafe-address {
    font-size: 2.3vh;
    color: #A4A3A1;
    line-height: normal;
 margin: 1.2vh 0 0;
}

p.comment {
    font-size: 2vh;
}

.btn-fill-green {
    background-color: #129b81;
    color: #ededed;
    border: 1px solid transparent
}
.mode-row {
  display: flex;
  align-items: center;
  margin-top: 2.3vh;
}
.marketplace-card-content {
 
  font-size: 2.3vh;
}

.mode-checkbox {
  width: 3.2vh;
  height: 3.2vh;

  background: #464646;

  border: 2px solid #464646;
  border-radius: 0.5vh;

  margin-right: 1.7vh;

  cursor: pointer;
}

.mode-description {
  background: #464646;
  color: #ededed;
  padding-left: 2vh;
  padding-right: 1vh;
  position: relative;
  left: -1vh;
  z-index: 0;
  font-size: 1.6vh;
  border-top-right-radius: 0.5vh;
  border-bottom-right-radius: 0.5vh;
}

.mode-icon {
  z-index: 2;
 
}

.first-comment {
  padding-top: 0 !important;
}

.balance-badge {
  border: 2px solid #129b81;
  color: #129b81;
  padding: 2vh 0.5vh;
  align-self: center;
  height: 15.4vh;
  line-height: 1.2;
  border-radius: 1.3vh;
  text-align: center;
  display: block;
  width: 30vh;
  font-size: 6vh;
}

span.balance-currency {
    font-size: 2.7vh;
    display: block;
}

.balance-badge.red {
  color: #e2223b;
  border: 2px solid #e2223b;
}

</style>